 import { CONFIRMATION_LINK } from "@/helper/consts";

export function goToConfirmation() {
  document.location.href = CONFIRMATION_LINK + `?redirect=${document.location.href}`
}
